import { ThemeProvider } from '@/context/ThemeContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Solutions from './components/Solutions';
import Industries from './components/Industries';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <ThemeProvider>
      <div className="min-h-screen transition-colors duration-500">
        <Navbar />
        <main>
          <Hero />
          <Solutions />
          <Industries />
          <HowItWorks />
          <Benefits />
          <Contact />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}